import React from "react";
import styled from "styled-components";

const StyledProgramSidebar = styled.div`
  .sidebarItems {
    display: grid;
    grid-template-rows: auto;
    grid-row-gap: 2rem;
  }
`;

const ProgramSidebar = props => {
  return (
    <StyledProgramSidebar>
      <div className="sidebarItems">{props.children}</div>
    </StyledProgramSidebar>
  );
};

export default ProgramSidebar;
